import { useCallback } from 'react'

import { useBridge } from '../bridge'

const EXIT_TIMEOUT_MS = 2000

export function useExitWebView(fallbackUrl?: string) {
  const { callHandler } = useBridge()

  return useCallback(() => {
    const redirect = () => {
      if (fallbackUrl) {
        window.location.href = fallbackUrl
      }
    }

    const timer = setTimeout(redirect, EXIT_TIMEOUT_MS)

    callHandler('closeWebView')
      .then(() => clearTimeout(timer))
      .catch(() => {
        clearTimeout(timer)
        redirect()
      })
  }, [callHandler, fallbackUrl])
}
